<!--
 * @Author: your name
 * @Date: 2020-08-18 11:28:28
 * @LastEditTime: 2024-02-08 18:34:56
 * @LastEditors: dengfang 36882215@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/wage/modal/add-project.vue
-->
<template>
  <div>
    <section>
      <p>1: {{ type === 'add' ? $t('47') : $t('down_update_temp') }}</p>
      <span class="upload-dialog-des">{{ $t('46') }}</span>
      <el-row>
        <el-col>
          <el-button class="el-icon-download" @click="handleExport()">{{ $t('778') }}</el-button>
        </el-col>
      </el-row>
    </section>
    <section>
      <p>2: {{ $t('39') }}</p>
      <el-upload
        class="upload-demo"
        drag
        ref="upload"
        :data="formData"
        :action="uploadUrl"
        :file-format="fileFormat"
        :multiple="multiple"
        :headers="baseHeaders"
        :before-upload="beforeUploadHandle"
        :on-success="successHandle"
        :on-error="errorHandle"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          <em>{{ $t('728') }}</em>
        </div>
        <div class="el-upload__tip" slot="tip">{{ $t('40') }}</div>
      </el-upload>
    </section>
    <section style="text-align: center; color: #409eff">
      <p v-if="uploadStatus">
        <span v-if="type === 'add'">
          {{ $t('978') }}:
          {{
            $t('43', {
              x: uploadSuccessCount,
              y: update_count,
              z: uploadFailCount
            })
          }}
        </span>
        <span v-else>
          {{ $t('978') }}:
          {{
            $t('update_result', {
              x: uploadSuccessCount,
              y: uploadFailCount
            })
          }}
        </span>
      </p>
      <p
        v-if="feedbackFileUrl"
        style="text-decoration: underline; margin-top: 10px; cursor: pointer"
        @click="handleOpenUrl"
      >
        {{ $t('download_excel_result') }}
      </p>
    </section>
  </div>
</template>

<script>
import { baseHeaders } from 'util/axios-request'
import { utilCookies } from '@/util/cookies'
const baseURL = process.env.VUE_APP_BASE_API
export default {
  props: {
    subProjectId: String,
    type: String // add 批量导入  update 批量修改
  },
  data() {
    return {
      multiple: true,
      fileFormat: ['.xls', '.xlsx'],
      baseHeaders: baseHeaders(),
      fileSize: 5,
      uploadHeaders: {},
      successFileList: [],
      uploadStatus: false,
      uploadTotalCount: 0, // 总数
      uploadSuccessCount: 0, // 成功数
      uploadFailCount: 0, // 失败数
      update_count: 0, // 覆盖数
      feedbackFileUrl: '',
      form: {
        name: ''
      },
      formData: {
        sub_project_id: this.subProjectId
      }
    }
  },
  computed: {
    uploadUrl() {
      return this.type === 'add' ? baseURL + 'web/staff/importStaff' : baseURL + '/web/staff/importUpdateStaff'
    }
  },
  // TODO 模版链接替换
  methods: {
    async handleExport() {
      // 模版下载
      const lang = (utilCookies.getLanguage() && utilCookies.getLanguage().substring(0, 2)) || 'th'
      let res = ''
      if (this.type === 'update') {
        switch (lang) {
        case 'zh':
          res = 'https://sg-ali-oss-bhorb-tra.oss-ap-southeast-1.aliyuncs.com/assets/file/StaffInfo-Edit-Zh-c4938f8df2d97e71a55690fe01475777.xlsx'
          break
        case 'th':
          res = 'https://sg-ali-oss-bhorb-tra.oss-ap-southeast-1.aliyuncs.com/assets/file/StaffInfo-Edit-Th-771afb2cfe4e30836eb7e48f34d4b26d.xlsx'
          break
        case 'en':
          res = 'https://sg-ali-oss-bhorb-tra.oss-ap-southeast-1.aliyuncs.com/assets/file/StaffInfo-Edit-En-39fd4d7ba4e81fb19ef91362be012c2f.xlsx'
          break
        case 'id':
          res = 'https://sg-ali-oss-bhorb-tra.oss-ap-southeast-1.aliyuncs.com/assets/file/StaffInfo-Edit-Id-08b6e0ef9c1c8c729e1a69811b9cd740.xlsx'
          break
      }
      }
      if (this.type === 'add') {
        switch (lang) {
        case 'zh':
          res = 'https://sg-ali-oss-bhorb-tra.oss-ap-southeast-1.aliyuncs.com/assets/file/StaffInfo-Add-Zh-5e9ff7af9eaeda2059c45880f999ca3d.xlsx'
          break
        case 'th':
          res = 'https://sg-ali-oss-bhorb-tra.oss-ap-southeast-1.aliyuncs.com/assets/file/StaffInfo-Add-Th-fbb4ff5a68da2c92291f85745dd3ef88.xlsx'
          break
        case 'en':
          res = 'https://sg-ali-oss-bhorb-tra.oss-ap-southeast-1.aliyuncs.com/assets/file/StaffInfo-Add-En-f94b479469f95f2fc8c60366a95b25b0.xlsx'
          break
        case 'id':
          res = 'https://sg-ali-oss-bhorb-tra.oss-ap-southeast-1.aliyuncs.com/assets/file/StaffInfo-Add-Id-3803557c1b5e99a04d79c8a95f9f1cf5.xlsx'
          break
      }
      }
      window.open(res)
    },
    beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(
            this.$t('729', {
              fileFormat: this.fileFormat.join()
            })
          )
          return false
        }
      }
      // 文件大小
      if (!(file.size / 1024 / 1024 < this.fileSize)) {
        this.$message.error(
          this.$t('730', {
            fileSize: this.fileSize
          })
        )
        return false
      }
    },
    // 上传成功+
    successHandle(res, file) {
      const response = res
      const data = response.data
      if (response && response.code === 1) {
        this.uploadStatus = true
        this.uploadSuccessCount = this.type === 'add' ? data.insert_count : data.success_count
        this.uploadFailCount = data.error_count
        this.update_count = data.update_count
        this.feedbackFileUrl = res.data.down_load_excel.object_url
        // window.open(res.data.down_load_excel.object_url)
        // if (data.upload_result_state === 1) {
        //   // 全部成功
        //   this.uploadTotalCount = data.upload_total_count
        //   this.$message.success(this.$t('935'))
        // } else if (data.upload_result_state === 5) {
        //   // 部分成功
        //   this.uploadTotalCount = data.upload_total_count
        //   this.uploadSuccessCount = data.insert_count
        //   this.uploadFailCount = data.error_count
        //   this.feedbackFileUrl = data.feedback_file_url
        //   this.$message.error(this.$t('936'))
        // } else if (data.upload_result_state === 3) {
        //   // 全部失败
        //   this.uploadTotalCount = data.upload_total_count
        //   this.uploadSuccessCount = data.insert_count
        //   this.uploadFailCount = data.upload_fail_count
        //   this.feedbackFileUrl = data.feedback_file_url
        //   this.$message.error(this.$t('937'))
        // }
      }
    },
    handleOpenUrl() {
      window.open(this.feedbackFileUrl)
    },
    // 上传失败
    // err, file, fileList
    errorHandle(err, file) {
      const index = this.$refs.upload.uploadFiles.findIndex(v => v.name === file.name)
      this.$refs.upload.uploadFiles.splice(index, 1)
      this.$message.error('upload error')
      throw err
    },
    resetDate() {
      this.uploadTotalCount = 0 // 总数
      this.uploadSuccessCount = 0 // 成功数
      this.uploadFailCount = 0 // 失败数
      this.feedbackFileUrl = ''
      this.uploadStatus = false
      this.update_count = 0
    },
    // 弹窗关闭时
    closeHandle() {
      this.reset()
      this.resetDate()
    },
    reset() {
      this.$refs.upload.clearFiles()
      this.successFileList = []
    }
  },
  watch: {
    successFileList: {
      handler(val) {
        if (val.length) this.$emit('uploadSuccess', val)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
section {
  margin-bottom: 20px;
}
.upload-dialog-des {
  display: block;
  font-size: 12px;
  line-height: 30px;
  color: #ccc;
}
.upload-demo {
  margin-top: 15px;
  text-align: center;
}
</style>
